<script lang="ts">

    import { GoogleAuth, FacebookAuth } from '@beyonk/svelte-social-auth';
    import { createEventDispatcher } from 'svelte';
    import { user } from '../Services';

    const dispatch = createEventDispatcher();

    function googleAuthSuccess(event: CustomEvent) {
        const profile = event.detail.user.getBasicProfile();
        const name = profile.getName();
        const image = profile.getImageUrl();
        user.set({ name, image });
        dispatch('auth_success');
    }

    function facebookAuthSuccess(event) {
        console.log('facebookAuthSuccess', { event });
        dispatch('auth_success');
    }

</script>

<style lang="scss">

    .social-auth {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 1rem;
    }

</style>

{#if !$user}
<div class="social-auth">
    <div class="social-auth-btn">
        <GoogleAuth
            text="Acceder con Google"
            clientId="389935151090-iaqks89rvr452uhmg83fhh3d3s7socea.apps.googleusercontent.com"
            on:auth-success={googleAuthSuccess} />
    </div>
    <div class="social-auth-btn">
        <FacebookAuth
            text="Acceder con Facebook"
            appId="1093972544756132"
            on:auth-success={facebookAuthSuccess} />
    </div>
</div>
{/if}
